
import React, { useEffect, useState } from 'react';

export const RateCardDurationActionComponent = ({ selectDurUnit, durationBaseMax, durationIncrement, durationChargePerIncrement }: any) => {
    const [durationData, setDurationData] = useState([]);

    const calculateCharges = () => {
        const durations = [];
        let cost = 0;
        for (let i = durationBaseMax; durations?.length < 3; i += durationIncrement) {
            if (i > durationBaseMax) {
                cost += durationChargePerIncrement;
            }
            durations.push({ duration: i, cost });
        }
        setDurationData(durations);
    }
    useEffect(() => {
        calculateCharges();
    }, []);
    return (


        <div className="max-w-md mx-auto p-4 bg-white shadow-lg rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Duration and Waiting Charges</h2>

            {/* Table for displaying charges */}
            <table className="w-full border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="border px-4 py-2">Duration ({selectDurUnit})</th>
                        <th className="border px-4 py-2">Charges (₹)</th>
                    </tr>
                </thead>
                <tbody>
                    {durationData.map((item, index) => (
                        <tr key={index} className="text-center">
                            <td className="border px-4 py-2">{item.duration} {selectDurUnit}</td>
                            <td className="border px-4 py-2">₹{item.cost}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>


    )
}
export default RateCardDurationActionComponent;
